Vue.component('app-invoice-pay', {

    props: {
        'invoice': {
            'required': true
        },
        'user': {
            'required': true
        },
        scriptendpoint: ""
    },

    /*
     * Initial state of the component's data.
     */
    data: function () {
        return {
            redirect_form_key:[],
            instantlink: '',
            payment_token: '',
            instant_eft_success: false,
            forms: {
                pay: $.extend(true, new AppForm({
                    busy: false,
                    paymentOption: "cc",
                    card: null,
                    terms: false
                }), App.forms.pay)
            },
            addingNewCard: false,
            newcard: {
                number: '',
                holder: '',
                exp_month: '',
                exp_year: '',
                cvv: '',
                return: '',
                errors: []
            },
            threeDs: {
                url: '',
                connector: '',
                MD: '',
                TermUrl: '',
                PaReq: ''
            },
            readyForThreeDs: false,
            checkoutId: null,
            entityId: null
        };
    },

    ready: function() {
        window.addEventListener("message", (event) => {
            if (typeof event.data == 'string') {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.pay.busy = false;
                        swal.close()
                    }, 2000)
                }
                catch(e){
                    this.forms.pay.busy = false;
                    swal.close()
                }
            }
        });
    },


    mounted() {
        this.loadPeachScript();
    },


    methods: {

         loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                console.log(this.scriptendpoint);

                document.head.appendChild(script);
            });
        },

        closeModal() {
            $("#checkout_model").modal("hide");
            this.checkoutId = null;
        },

        handleSuccess(event) {
            this.closeModal();
        },

        popEft() {

            if (!this.validate()) {
                return;
            }

            this.process();
            this.forms.pay.busy = true;
            this.getEftLink();
        },

        addCard() {
            this.newcard.return = `/invoices/settle/${this.invoice.id}?threeDs=yes`;

            this.processPayment();

            this.$http.post('/account/billing', this.newcard)
                .then(response => {
                    if(response.data.redirect === undefined || response.data.redirect === null) {
                        this.saveCard(response.data.id);
                        this.addingNewCard = false;
                        swal.close();
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (var i = response.data.redirect.parameters.length - 1; i >= 0; i--) {
                            this.redirect_form_key.push({
									form_key: response.data.redirect.parameters[i].name,
									form_value: response.data.redirect.parameters[i].value
							});
                            this.threeDs[response.data.redirect.parameters[i].name] = response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }
                })
                .catch(errors => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        /**
         * Save User Card
         */
        saveCard(id) {
            this.$http.post('/account/billing/card', { id: id })
                .then(response => {
                    this.user.cards.push(response.data.card)
                    this.forms.subscription.card = response.data.card.id;
                    swal.close()
                })
                .catch(errors => {
                    if(errors.data.number) {
                        swal({
                            type: 'error',
                            title: 'Whoops',
                            text: errors.data.number
                        })
                    }
                })
        },

        pay() {
            this.forms.pay.errors.forget();
            this.forms.pay.busy = true;
            //this.process();
            this.sendPay();
        },

        sendPay() {

            if (!this.validate()) {
                return;
            }

            if(this.forms.pay.paymentOption == 'eft' && this.instant_eft_success == false) {
                this.forms.pay.busy = true;
                return;
            }


            if (
				this.forms.pay.paymentOption == 'cc' &&
				!this.forms.pay.card
			) {
				swal({
					type: 'warning',
					title: 'Error',
					text:
						'Unable to register without credit card, please select credit card',
				});
                this.forms.pay.busy = false;
				return;
			}


            var payload = {
                terms: this.forms.pay.terms,
                card: this.forms.pay.card,
                paymentOption: this.forms.pay.paymentOption,
            };

            this.processPayment();
            this.$http.post(`/invoices/settle/${this.invoice.id}`, payload)
                .success((response) => {
                    this.forms.pay.busy = false;
                    swal.close();
                    window.location = '/dashboard/invoices';
                })
                .error((errors) => {
                    this.forms.pay.busy = false;

                    if(errors && errors.errors && errors.errors.card) {
                        swal({
                            type: 'error',
                            title: 'Whoops',
                            text: errors.errors.card
                        })
                    } else if (errors && errors.message && errors.message !== '') {
                        swal({
                            type: "error",
                            title: "Whoops",
                            text: errors.message
                        });
                    } else {
                        swal.close();
                    }

                    this.forms.pay.errors.set(errors);
                });
        },

        cancelPayment: function () {
            this.forms.pay.busy = false;
        },


        getEftLink: async function() {
            this.processPayment();
            this.showModal = true;
            await this.loadPeachScript();

            let data = {
                invoice: this.invoice.id
            };

            this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                    let message = "Unable to process your request!";

                    if (error.status == 422) {
                        message = error.data.message;
                    }
                    swal({
                        type: "warning",
                        title: "Error",
                        text: message,
                        showConfirmButton: true
                    });
                    this.forms.pay.busy = false;
                    return;
                });
        },
        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                        const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendPay();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                                showConfirmButton: true
                            });

                            this.forms.pay.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.pay.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.pay.busy = false;
                    }
                }
            });

            checkout.render("#payment-form");
        },


        startListener: function () {
            var pusher = new Pusher('5e9e56a5a0ebaf5484b0', {
              cluster: 'mt1'
            });

            var channel = pusher.subscribe('instantefts');

            channel.bind("App\\Events\\InstantEftNotificationReceived", (data) => {
              if(this.payment_token == data.payment_key) {
                if(data.success === true) {
                    this.process();
                    this.instant_eft_success = true;
                    this.sendPay();
                } else {
                    this.cancelPayment();
                    swal({
                        type: 'error',
                        title: 'Error',
                        text: "Your Payment has failed, please try again"
                    })
                }
              }
            });

        },


        processPayment: function() {
            swal({
                type: "warning",
                title: "Payment Processing",
                text: "Please wait while we are processing your payment.Do not Refresh page or close browser"
            })
        },
        process() {
            swal({
                title: "",
                text: '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #ffffff;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: 'no-bg'
            });
        },

        validate: function() {
            if (!this.forms.pay.terms) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Please accept term's and condition to process booking!"
                });
                this.forms.pay.busy = false;
                return false;
            }

            return true;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/invoices/dashboard/pay.js